import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      initialFormData: null,
      toRoute: null,
    }
  },
  computed: {
    ...mapGetters(['unsavedData']),
    checkDataChangedTitle() {
      return `checkDataChanged${this.$route.name}`
    },
  },
  beforeCreate() {
    this.$root.$off(`checkDataChanged${this.$route.name}`)
  },
  created() {
    this.$root.$on(`checkDataChanged${this.$route.name}`, toRoute => {
      this.toRoute = toRoute

      if (this.isDataChanged()) {
        this.saveData(toRoute)
      } else {
        this.$store.dispatch('unsavedData', false)
      }
    })
  },
  methods: {
    initialForm(formData) {
      formData = formData ?? this.formData
      this.initialFormData = JSON.stringify(formData)
      this.$store.dispatch('unsavedData', true)
    },
    isDataChanged(formData) {
      formData = formData ?? this.formData
      return this.unsavedData
        ? this.initialFormData !== JSON.stringify(formData)
        : false
    },
    goToRoute() {
      this.$store
        .dispatch('unsavedData', false)
        .then(this.$router.push(this.toRoute))
    },
    checkData() {
      if (this.isDataChanged()) {
        this.saveData()
      }
    },
  },
}
